import React, { Fragment, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Input, Card, CardBody, Container, Row, Col, Button, FormGroup, Label, List, Table, Media, CardHeader, Collapse } from 'reactstrap';
import { useWorkSheetsDay } from '../../../hooks/workOrder/useWorkSheetsDay';
import Datetime from 'react-datetime';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import search from '../../../assets/images/search-not-found.png';
import './styleWorkDay.css';
import { pyrsa } from '../../../constant/globalConstantsTypeClients';

//MULTISELECT
import '../../../hooks/componentMultiSelect/MultiSelectDemo.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import { MultiSelect } from 'primereact/multiselect';

export const IndexWorkSheetsDay = () => {

    const { workOrderExams, sections, sectionsDefault, branches, branchesDefault, nim,
        exam_select, date_search, date_search_end,
        handleInputChange, handlePickerValues, handleDate, handleSelectValues, checkTypePrint,
        FilterData, loading, downloadSheetWorkDay, loadingPdf, statusPrint,
        changeCheckbox, changeCheckboxBranch, examsFilter, navigateCaptureResults, setselectedSections, selectedSections, sectiondefault,
        getNimsFromRange, changeFiltersRangeNim, loadingWorkSheets
    } = useWorkSheetsDay();
    console.log("🚀 ~ IndexWorkSheetsDay ~ workOrderExams:", workOrderExams)
    const txtsection = localStorage.getItem('TextAS');

    if (exam_select !== null) {
    }


    const [filters, setFilters] = useState(true);
    const [filterDate, setFilterDate] = useState(false);
    const [filtersRangeNim, setFiltersRangeNim] = useState(false);
    const urlHelen = localStorage.getItem('url_helen');

    const changeFilters = (typeFilter) => {
        switch (typeFilter) {
            case "date":
                setFilters(!filters);
                setFilterDate(false);
                setFiltersRangeNim(false);
                break;
            case "search":
                setFilters(false);
                setFilterDate(!filterDate);
                setFiltersRangeNim(false);

                break;
            case "range":
                setFilters(false);
                setFilterDate(false);
                setFiltersRangeNim(!filtersRangeNim);

                break;
            default:
                break;
        }
    }


    return (
        <Fragment>
            <div className='container-global-zoom'> 
                <Row className='m-b-10'>
                    <Col className="default-according style-1 faq-accordion job-accordion position-relative" id="accordionoc" xs="12" sm="6" md="6" lg="3" xl="3">
                        <div className="custom-scroll-container">
                            <Row >
                                <Col xl="12">
                                    <Card>
                                        <CardHeader style={{ padding: "0" }}>
                                            <div style={{ background: "#0079c7", borderRadius: "11px", padding: "17px 18px", display: "flex", alignItems: "center" }} >
                                                <Button color="link" className="p-0 text-white d-flex align-items-center" data-toggle="collapse" onClick={() => changeFilters("date")} data-target="#collapseicon" aria-expanded={filters} aria-controls="collapseicon" style={{ gap: "10px" }} >
                                                    <span className='labelFilter'>Filtros de búsqueda</span>
                                                </Button>
                                            </div>
                                        </CardHeader>

                                        <Collapse isOpen={filters}>
                                            <CardBody className="p-4">
                                                <Row className="mb-3">
                                                    <Col md="12">
                                                        <Label>
                                                            Rango de NIMs
                                                        </Label>
                                                    </Col>
                                                    <Col xs="12" sm="12" md="6" className="mb-2">
                                                        <Input type="number" name="init_range_nim" placeholder="Desde..." className="form-control form-control-sm" onChange={(e) => changeFiltersRangeNim(e.target.value, "init_range_nim")} style={{ borderRadius: "7px" }} />
                                                    </Col>
                                                    <Col xs="12" sm="12" md="6">
                                                        <Input type="number" name="end_range_nim" placeholder="Hasta..." className="form-control form-control-sm" onChange={(e) => changeFiltersRangeNim(e.target.value, "end_range_nim")} style={{ borderRadius: "7px" }} />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md="12">
                                                        <Label>
                                                            Fecha de admisión <span className="text-danger">*</span>
                                                        </Label>
                                                    </Col>
                                                    <Col md="6">
                                                        <Datetime
                                                            inputProps={{
                                                                placeholder: "Inicio",
                                                                className: "form-control form-control-sm",
                                                                style: { borderRadius: "7px" }
                                                            }}
                                                            timeFormat={false}
                                                            dateFormat="YYYY-MM-DD"
                                                            value={date_search}
                                                            locale="es"
                                                            onChange={(e) => handlePickerValues(e, "date_search")}
                                                        />
                                                    </Col>
                                                 <Col md="6">
                                                        <Datetime
                                                            inputProps={{
                                                                placeholder: "Fin",
                                                                className: "form-control form-control-sm w-100",
                                                                style: { borderRadius: "7px" }
                                                            }}
                                                            timeFormat={false}
                                                            dateFormat="YYYY-MM-DD"
                                                            value={date_search_end}
                                                            locale="es"
                                                            onChange={(e) => handlePickerValues(e, "date_search_end")}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md="12">
                                                        <Label>

                                                            Secciones <span className="text-danger">*</span>
                                                        </Label>
                                                        <MultiSelect
                                                            className="w-100"
                                                            value={selectedSections}
                                                            options={sectiondefault}
                                                            onChange={(e) => changeCheckbox(e.value)}
                                                            optionLabel="name"
                                                            placeholder="Selecciona secciones..."
                                                            maxSelectedLabels={3}
                                                            selectedItemsLabel="Secciones agregadas"
                                                            filter
                                                            filterPlaceholder="Buscar sección..."
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="12">
                                                        <Label>
                                                            Sucursal <span className="text-danger">*</span>
                                                        </Label>
                                                        <Select
                                                            isMulti
                                                            name="branches"
                                                            isClearable={true}
                                                            placeholder="Selecciona una o más sucursales"
                                                            noOptionsMessage={() => "Sin resultados"}
                                                            options={branches}
                                                            onChange={(e) => changeCheckboxBranch(e)}
                                                            defaultValue={branchesDefault}
                                                            style={{ borderRadius: "7px" }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className='m-t-5'>
                                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                        <Label>Tipo de impresión<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                    </Col>
                                                </Row>
                                                <Row className='m-t-5'>
                                                    <Col xs="6" sm="6" md="6" lg="6" xl="6">
                                                        <Label className="labelCheckPrint">{"Lista"}</Label> <br />
                                                        <Label className="switch">
                                                            <Input type="radio" name="checkTypePrint" value="list" checked={checkTypePrint === "list" ? true : false} onChange={(e) => handleDate(e, "checkTypePrint")} />
                                                            <span className="slider round"></span>
                                                        </Label>
                                                    </Col>
                                                    <Col xs="6" sm="6" md="6" lg="6" xl="6">
                                                        <Label className="labelCheckPrint">{"Detalle"}</Label> <br />
                                                        <Label className="switch">
                                                            <Input type="radio" name="checkTypePrint" value="detail" checked={checkTypePrint === "detail" ? true : false} onChange={(e) => handleDate(e, "checkTypePrint")} />
                                                            <span className="slider round"></span>
                                                        </Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md="12">
                                                        <div className="d-flex align-items-center justify-content-between mt-2">
                                                        <Button
                                                            color="primary"
                                                            outline
                                                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                                                            onClick={FilterData}
                                                        >
                                                            Filtrar
                                                        </Button>

                                                        <div className="mx-3" style={{ width: "1px", height: "30px", backgroundColor: "#ffffffff" }} />

                                                        <Button
                                                            color="danger"
                                                            outline
                                                            className={loadingPdf ? "disabled progress-bar-animated progress-bar-striped" : ""}
                                                            onClick={downloadSheetWorkDay}
                                                        >
                                                            Imprimir
                                                        </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>

                                    <br />

                                    <Card>
                                        <CardHeader className='bg-secondary'>
                                            <h5 className="mb-0">
                                                <Button color="link pl-0" data-toggle="collapse" onClick={() => changeFilters("search")}
                                                    data-target="#collapseicon" aria-expanded={filterDate} aria-controls="collapseicon"><i className="icon-search fIcon"></i>&nbsp; &nbsp; &nbsp; &nbsp; <label className='labelNim'>Busqueda por NIM</label>   </Button>
                                            </h5>
                                        </CardHeader>
                                        <Collapse isOpen={filterDate}>
                                            <CardBody className="p-3">
                                                <Row>
                                                    <Col md="12 m-0">
                                                        <Label className="col-form-label">Sucursal<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                        <FormGroup>
                                                            <Select
                                                                isMulti
                                                                name="branches"
                                                                isClearable={true}
                                                                placeholder="Selecciona una sucursal"
                                                                noOptionsMessage={() => "Sin resultados"}
                                                                options={branches}
                                                                onChange={(e) => changeCheckboxBranch(e)}
                                                                defaultValue={branchesDefault}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <FormGroup className="col-md-12">
                                                        <Label className="">Ingresa el NIM  o Nombre a buscar<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>

                                                        <Input className='form-control form-control-sm input-air-primary' name="nim" value={nim} onChange={handleInputChange} />
                                                    </FormGroup>
                                                    <Col md="12">
                                                        <Button outline color="primary" className={(loading ? "text-center disabled progress-bar-animated progress-bar-striped" : "text-center")} onClick={FilterData}> Filtrar</Button>
                                                    </Col> <br />

                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                </Col>
                            </Row>
                        </div>

                    </Col>

                    <Col sm="9">
                        {loadingWorkSheets ? (
                            <div className="text-center py-5" style={{ marginTop: "80px" }}>
                                <img
                                alt="modal-preview"
                                src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")}
                                className="fa-spin"
                                style={{ width: "15%" }}
                                />
                                <p className="txt-secondary mt-2">Cargando hoja de trabajo...</p>
                            </div>
                            ) : (
                                Object.entries(workOrderExams).length > 0 ?
                                    Object.entries(workOrderExams).map((obj, key) => {
                                        console.log(obj);
                                        const _arrayDoctors = obj[1][0].doctors ? obj[1][0].doctors.split(',').map(name => name.trim()) : [];

                                        return <Row key={obj[0]}>
                                          
                                            <Col xl="12" >
                                                <Card className={`'ribbon-vertical-left-wrapper'`}>
                                                    {obj[1][0].is_micro_sanitary ? (
                                                        <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 4px", fontSize: "11px", fontFamily: "Arial, sans-serif"}}>
                                                            <thead>
                                                                <tr>
                                                                    <th colSpan={10} style={{ backgroundColor: "#0f597b", height: "25px", borderRadius: "6px 6px 0 0"}}></th>
                                                                </tr>
                                                            </thead>
                                                                <tbody>
                                                                    <tr style={{ backgroundColor: "#f7f7f7ff", borderRadius: "6px 6px 0 0" }}>
                                                                        <td
                                                                            style={{
                                                                                textAlign: "center",
                                                                                verticalAlign: "middle",
                                                                                borderRadius: "6px 0 0 6px"
                                                                            }}
                                                                            rowSpan={2}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    obj[1][0].income_type === "Público general"
                                                                                        ? require("../../../assets/images/user/personal.png")
                                                                                        : obj[1][0].income_type === "Empresas"
                                                                                        ? require("../../../assets/images/user/company.png")
                                                                                        : require("../../../assets/images/user/personal.png")
                                                                                }
                                                                                alt="Paciente"
                                                                                style={{
                                                                                    width: 40,
                                                                                    height: 40,
                                                                                    borderRadius: "50%"
                                                                                }}
                                                                            />

                                                                            <div style={{ marginTop: 4 }}>
                                                                                <span
                                                                                    className="f-w-400 f-11 badge badge-light-success"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        display: "inline-block",
                                                                                        padding: "0.25em 0.5em",
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                    onClick={() => navigateCaptureResults(obj[0])}
                                                                                >
                                                                                    <strong>{obj[1][0].nim}</strong>
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td style={{ padding: "4px" }} colSpan={2}>
                                                                            <strong>Tipo de ingreso:</strong> {obj[1][0].income_type}
                                                                        </td>

                                                                        <td style={{ padding: "4px" }} colSpan={2}>
                                                                            {urlHelen === pyrsa && obj[1][0].income_type === "Empresas" && (
                                                                                <>
                                                                                    <strong>Empresa:</strong> {obj[1][0].name_company ?? "—"}
                                                                                </>
                                                                            )}
                                                                        </td>

                                                                        <td style={{ padding: "4px" }} colSpan={2}>
                                                                            {urlHelen === pyrsa &&
                                                                                obj[1][0].income_type === "Empresas" &&
                                                                                obj[1][0].contract_number_agreement && (
                                                                                    <>
                                                                                        <strong>Convenio:</strong>{" "}
                                                                                        {obj[1][0].contract_number_agreement}
                                                                                    </>
                                                                                )}
                                                                        </td>

                                                                        <td style={{ padding: "4px", textAlign: "right" }}>
                                                                            {obj[1][0].date} / {obj[1][0].name_branch}
                                                                        </td>
                                                                    </tr>

                                                                    <tr
                                                                        style={{
                                                                            backgroundColor: "#f0f0f0ff",
                                                                            borderRadius: "0 0 6px 6px"
                                                                        }}
                                                                    >
                                                                        <td style={{ padding: "4px" }} colSpan={7}>
                                                                            <strong>Observaciones:</strong>{" "}
                                                                            {obj[1][0].observations
                                                                                ? obj[1][0].observations
                                                                                : "Sin observaciones"}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                        </table>
                                                    ) : (
                                                       <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "separate",
                                                                borderSpacing: "0 4px",
                                                                fontSize: "11px"
                                                            }}
                                                            >
                                                            <thead>
                                                                <tr
                                                                style={{
                                                                    backgroundColor: "#3b96d3d8",
                                                                    color: "#f0f0f0ff",
                                                                    fontSize: "11px"
                                                                }}
                                                                >
                                                                <th
                                                                    style={{
                                                                    padding: "4px",
                                                                    textAlign: "center",
                                                                    borderRadius: "6px 0 0 0"
                                                                    }}
                                                                ></th>
                                                                <th style={{ padding: "4px" }}>Nombre</th>
                                                                <th style={{ padding: "4px" }}>Edad</th>
                                                                <th style={{ padding: "4px" }}>Género</th>
                                                                <th style={{ padding: "4px", borderRadius: "0 6px 0 0", textAlign:"right"}}>
                                                                    Fecha / Sucursal
                                                                </th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr style={{ backgroundColor: "#f0f0f0ff" }}>
                                                                <td
                                                                    style={{
                                                                    textAlign: "center",
                                                                    verticalAlign: "middle",
                                                                    borderRadius: "6px 0 0 6px"
                                                                    }}
                                                                    rowSpan={2}
                                                                >
                                                                    <img
                                                                    src={
                                                                        obj[1][0].gender === "Femenino"
                                                                        ? require("../../../assets/images/user/mujer.png")
                                                                        : require("../../../assets/images/user/hombre.png")
                                                                    }
                                                                    alt="Paciente"
                                                                    style={{ width: 40, height: 40, borderRadius: "50%" }}
                                                                    />
                                                                    <div style={{ marginTop: 4 }}>
                                                                    <span
                                                                        className="f-w-400 f-11 badge badge-light-primary"
                                                                        style={{
                                                                        cursor: "pointer",
                                                                        display: "inline-block",
                                                                        padding: "0.25em 0.5em",
                                                                        fontSize: "12px"
                                                                        }}
                                                                        onClick={() => navigateCaptureResults(obj[0])}
                                                                    >
                                                                        <strong>{obj[1][0].nim}</strong>
                                                                    </span>
                                                                    </div>
                                                                </td>

                                                                <td style={{ padding: "4px" }}>
                                                                    <strong>{obj[1][0].name_patient}</strong>
                                                                </td>
                                                                <td style={{ padding: "4px" }}>{obj[1][0].age}</td>
                                                                <td style={{ padding: "4px" }}>{obj[1][0].gender}</td>
                                                                <td style={{ padding: "4px", textAlign: "right" }}>
                                                                    {obj[1][0].date} / {obj[1][0].name_branch}
                                                                </td>
                                                                </tr>

                                                                <tr
                                                                style={{
                                                                    backgroundColor: "#f7f7f7ff",
                                                                    borderRadius: "0 0 6px 6px"
                                                                }}
                                                                >
                                                                <td style={{ padding: "4px" }}>
                                                                    <strong>Doctores:</strong>{" "}
                                                                    {_arrayDoctors && _arrayDoctors.length > 0
                                                                    ? _arrayDoctors.join(", ")
                                                                    : "Sin médico"}
                                                                </td>

                                                                <td style={{ padding: "4px" }}>
                                                                    <strong>Tipo de ingreso:</strong> {obj[1][0].income_type}
                                                                </td>

                                                                <td style={{ padding: "4px" }}>
                                                                    {urlHelen === pyrsa && obj[1][0].income_type === "Empresas" && (
                                                                    <>
                                                                        <strong>Empresa:</strong> {obj[1][0].name_company ?? "—"}
                                                                    </>
                                                                    )}
                                                                </td>

                                                                <td style={{ padding: "4px", borderRadius: "0 0 6px 0" }}>
                                                                    {urlHelen === pyrsa &&
                                                                    obj[1][0].income_type === "Empresas" &&
                                                                    obj[1][0].contract_number_agreement && (
                                                                        <>
                                                                        <strong>Convenios:</strong>{" "}
                                                                        {obj[1][0].contract_number_agreement}
                                                                        </>
                                                                    )}
                                                                </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    )}

                                                    {checkTypePrint === "list" ? (
                                                        <div style={{ overflowX: "auto", margin: "15px 10px", padding: 5}}>
                                                            {Object.values( obj[1].filter((exam) => exam.is_micro_sanitary).reduce((acc, exam) => {
                                                                const folio = exam.micro_sanitary_info.code;
                                                                if (!acc[folio]) acc[folio] = [];
                                                                    acc[folio].push(exam);
                                                                    return acc;
                                                                }, {})
                                                            ).map((examsGroup, key) => {
                                                                const info = examsGroup[0].micro_sanitary_info;

                                                                return (
                                                                    <div key={key} style={{ marginBottom: 20, background: "#f9fbfc", borderRadius: 10, padding: "10px 15px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)",}}>
                                                                        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", fontSize: 11, marginBottom: 8}}>
                                                                            <div><strong>Folio de muestra:</strong> {info.code}</div>
                                                                            <div><strong>Tipo de muestra:</strong> {info.type_sample}</div>
                                                                            <div><strong>Muestra:</strong> {info.sample_micro}</div>
                                                                        </div>

                                                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))", gap: "6px", marginTop: 8 }} >
                                                                            {examsGroup.map((exam, i) => (
                                                                                <div key={i} style={{ padding: "6px 10px", background: "#e9f4fa", borderRadius: 6, border: "1px solid #d3e7f1", fontSize: 11, display: "flex",alignItems: "center"}}>
                                                                                    <span style={{ flexShrink: 0 }}><strong>{exam.abbreviation_exam}:</strong></span>
                                                                                    <span style={{ flexGrow: 1, borderBottom: "1px solid #aaa", marginLeft: 5, marginTop: "9px" }}></span>
                                                                                </div>
                                                                            ))}
                                                                        </div>

                                                                        {obj[1][0].observations && (
                                                                            <div style={{ fontSize: 11, marginTop: 8, background: "#fff8f6", borderLeft: "3px solid #dc3545", padding: "5px 8px", borderRadius: 5 }} >
                                                                                <i className="icofont icofont-warning-alt f-18 text-danger"></i>
                                                                                &nbsp;<b>Observaciones:</b>
                                                                                <br />
                                                                                <span>{obj[1][0].observations}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}

                                                            {/* --- is_micro_sanitary --- */}
                                                            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "8px"}} >
                                                                {obj[1].filter((exam) => !exam.is_micro_sanitary).map((exam, index) => (
                                                                    <div key={"nonmicro-" + index} style={{ padding: "6px 10px", background: "#f7fcff", fontSize: 11, borderRadius: 8, border: "1px solid #d9edf5", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 0 2px rgba(0,0,0,0.05)" }}>                                                                    <span style={{ flexShrink: 0 }}>
                                                                        <strong>{exam.abbreviation_exam}:</strong>
                                                                            </span>
                                                                        <span style={{ flexGrow: 1, borderBottom: "1px solid #aaa", marginLeft: 5, marginTop: "9px"}}></span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            {obj[1][0].observations && (
                                                                <div
                                                                style={{
                                                                    fontSize: 11,
                                                                    marginTop: 8,
                                                                    background: "#f6fcffff",
                                                                    borderLeft: "3px solid #356fdcff",
                                                                    padding: "6px 10px",
                                                                    borderRadius: 5,
                                                                }}
                                                                >
                                                                <i className="icofont icofont-warning-alt f-18 text-primary"></i>&nbsp;
                                                                <b>Observaciones:</b>&nbsp;<span>{obj[1][0].observations}</span>
                                                                
                                                                </div>
                                                            )}
                                                            
                                                        </div>                          
                                                        ) : (

                                                            <>
                                                            <div
                                                                style={{
                                                                display: "grid",
                                                                gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
                                                                gap: "8px",
                                                                marginTop: 8,
                                                                marginLeft:10,
                                                                marginRight:10,
                                                                marginBottom:12
                                                                }}
                                                            >
                                                                {obj[1].map((exam, key2) => {
                                                                const isSingle = exam.list_analytes.length === 1;
                                                                if (isSingle) {
                                                                    const analyte = exam.list_analytes[0];
                                                                    return (
                                                                    <div
                                                                        key={"exam-single-" + key2}
                                                                        style={{
                                                                        padding: "6px 10px",
                                                                        background: "#e9f4fa",
                                                                        borderRadius: 6,
                                                                        border: "1px solid #d3e7f1",
                                                                        fontSize: 11,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <span style={{ flexShrink: 0 }}>
                                                                        <strong>{analyte.code}: </strong>
                                                                        </span>
                                                                        <span
                                                                        style={{
                                                                            flexGrow: 1,
                                                                            borderBottom: "1px solid #aaa",
                                                                            marginLeft: 5,
                                                                            marginTop: "9px",
                                                                        }}
                                                                        ></span>
                                                                    </div>
                                                                    );
                                                                }

                                                                return (
                                                                    <div
                                                                    key={"exam-group-" + key2}
                                                                    style={{
                                                                        marginBottom: 15,
                                                                        background: "#f9fbfc",
                                                                        borderRadius: 10,
                                                                        padding: "10px 15px",
                                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                                        gridColumn: "1 / -1", 
                                                                    }}
                                                                    >
                                                                    <div
                                                                        style={{
                                                                        borderBottom: "1px solid #d3e7f1",
                                                                        paddingBottom: 6,
                                                                        marginBottom: 8,
                                                                        fontSize: 11,
                                                                        color: "#053b5aff",
                                                                        fontWeight: 600,
                                                                        }}
                                                                    >
                                                                        {exam.name_exam}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                        display: "grid",
                                                                        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                                                                        gap: "6px",
                                                                        }}
                                                                    >
                                                                        {exam.list_analytes.map((analyte, i) => (
                                                                        <div
                                                                            key={"analyte-" + i}
                                                                            style={{
                                                                            padding: "6px 10px",
                                                                            background: "#e9f4fa",
                                                                            borderRadius: 6,
                                                                            border: "1px solid #d3e7f1",
                                                                            fontSize: 11,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <span style={{ flexShrink: 0 }}>
                                                                            <strong>{analyte.code}: </strong>
                                                                            </span>
                                                                            <span
                                                                            style={{
                                                                                flexGrow: 1,
                                                                                borderBottom: "1px solid #aaa",
                                                                                marginLeft: 5,
                                                                                marginTop: "9px",
                                                                            }}
                                                                            ></span>
                                                                        </div>
                                                                        ))}
                                                                    </div>
                                                                    </div>
                                                                );
                                                                })}
                                                            </div>

                                                           {obj[1][0].observations && (
                                                                <div
                                                                style={{
                                                                    fontSize: 11,
                                                                    marginTop: 8,
                                                                    background: "#f6fcffff",
                                                                    borderLeft: "3px solid #356fdcff",
                                                                    padding: "6px 10px",
                                                                    borderRadius: 5,
                                                                }}
                                                                >
                                                                <i className="icofont icofont-warning-alt f-18 text-primary"></i>&nbsp;
                                                                <b>Observaciones:</b>&nbsp;<span>{obj[1][0].observations}</span>
                                                                
                                                                </div>
                                                            )}
                                                            </>

                                                        )}

                                                </Card>
                                            </Col>
                                        </Row>
                                    })
                                    :
                                    <Row>
                                        <Col sm="12">
                                            <Card>
                                                <CardBody>
                                                    <br />
                                                    <div className="search-not-found text-center">

                                                        <div>
                                                            <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "60%" }} alt="" /> <br />
                                                            <label className='f-w-600 f-14 badge badge-light-primary'>No se a registrado ninguna hoja de trabajo</label>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                            )}
                    </Col>

                </Row >
            </div >
        </Fragment >
    )
}
